import { isMetropolePathType, PathType } from './path-type.enum';

export enum DeductibleType {
  TroisCents = '300',
  CentCinquante = '150',
  CinqCents = '500',
}

export function getDefaultDeductibleTypeByPath(pathType: PathType | null | undefined): DeductibleType {
  if (pathType === PathType.ESSENTIELLE) {
    return DeductibleType.CinqCents;
  }

  // Parcours métropole MRH (hors Essentielle) : franchise par défaut à 150€
  if (isMetropolePathType(pathType ?? null)) {
    return DeductibleType.CentCinquante;
  }

  if (pathType === PathType.CONFORT) {
    return DeductibleType.TroisCents;
  }

  return DeductibleType.CentCinquante;
}
